import { render, staticRenderFns } from "./ActivityRules.vue?vue&type=template&id=0db70e72&scoped=true"
import script from "./ActivityRules.vue?vue&type=script&lang=js"
export * from "./ActivityRules.vue?vue&type=script&lang=js"
import style0 from "./ActivityRules.vue?vue&type=style&index=0&id=0db70e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db70e72",
  null
  
)

export default component.exports